import { format, isValid } from 'date-fns';
import { localeDateMap, LANGUAGES } from '../i18n/languages';

export default (rawDate, form = 'PP', locale = LANGUAGES[0]) => {
  const date = new Date(rawDate);
  return isValid(date)
    ? format(date, form, { locale: localeDateMap[locale] })
    : '-';
};
